import request from '@/utils/request'
// 生成时间:2022-06-09 17:39:22

// 查询document列表
export function listDocument(query) {
    var data={
        filterstr:"",
        orderby:query.orderby||"",
        opstr:query.opstr ||{},
        page_size:query.pageSize,
        page:query.pageNum
    };
    var filterstr={};
    for(var k in query){
     var item=query[k];
     if(k!="pageSize" && k!="pageNum"&&k!="opstr"&&k!="orderby"){
       filterstr[k]=item;
     }
    }
    data["filterstr"] = JSON.stringify(filterstr);
    data["opstr"] = JSON.stringify(data["opstr"]);
    data["orderby"] =  data["orderby"] ;//增加排序
    return request({
        url: '/general/document/list',
        method: 'post',
        data: data
    })
}

// 查询document详细
export function getDocument (id) {
    return request({
        url: '/general/document/get?id='+id,
        method: 'get'
    })
}


// 新增document
export function addDocument(data) {
    return request({
        url: '/general/document/add',
        method: 'post',
        data: data
    })
}

// 修改document
export function editDocument(data) {
    return request({
        url: '/general/document/edit',
        method: 'post',
        data: data
    })
}

// 删除document
export function delDocument(ids) {
    return request({
        url: '/general/document/del',
        method: 'post',
        data:{ids:ids}
    })
}

// 删除document查询模板
export function advquerydelDocument(ids) {
    return request({
        url: '/general/document/advquerydel',
        method: 'post',
        data:{ids:ids}
    })
}

// 添加document查询模板
export function advquerysaveDocument(data) {
    return request({
        url: '/general/document/advquerysave',
        method: 'post',
        data: data
    })
}
// 列表document查询模板列表
export function advquerylistDocument(businessname) {
    return request({
        url: '/general/document/advquerylist?businessname='+businessname,
        method: 'get'
    })
}
// 导出document
export function exportDocument(query,exportfields,tableColumn) {
     var data={
            filterstr:"",
            orderby:"",
            opstr:query.opstr ||{},
        };
        var filterstr={};
        for(var k in query){
         var item=query[k];
         if(k!="pageSize" && k!="pageNum"&&k!="opstr"){
           filterstr[k]=item;
         }
        }
        var tarexportfieldslist={};
        for(var k in tableColumn){
          var tlbf = tableColumn[k];
           for(var i in exportfields){
             var ef = exportfields[i]
             if(tlbf.field!="" && tlbf.field && tlbf.field!=null && tlbf.field == ef){
               tarexportfieldslist.push({"filed":ef,"title":tlbf.title});
               break;
             }
           }
        }

        data["filterstr"] = JSON.stringify(filterstr);
        data["opstr"] = JSON.stringify(data["opstr"]);
        data["exportfields"] = JSON.stringify(tarexportfieldslist);
        return request({
            url: '/general/document/export',
            method: 'post',
            data: data
        })
}
